export const environment = {
  production: false,
  portal1_url: 'https://portal.dev-portal.ocsla.mx',
  portal2_url: 'https://admin.dev-portal.ocsla.mx',
  portal3_url: 'https://portal.dev-proveedores.ocsla.mx',
  portal4_url: 'https://dashboard.dev-portal.ocsla.mx',
};